import template from "./pLicenseAgreements.html";
import moment from "moment";
import html2canvas from "html2canvas";
import pdfMake from "pdfmake/build/pdfmake.js";
import pdfFonts from "pdfmake/build/vfs_fonts.js";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export function pLicenseAgreementsDirective() {
  "ngInject";

  let directive = {
    restrict: "E",
    template: template,
    controller: pLicenseAgreementsController,
    controllerAs: "pLicenseAgreements",
    bindToController: true
  };

  return directive;
}

class pLicenseAgreementsController {
  constructor(Auth, Admin, Notes, $scope, $interval, bModal, ConnectionQuality) {
    "ngInject";

    this.Auth = Auth;
    this.Admin = Admin;
    this.Notes = Notes;
    this.$scope = $scope;
    this.$interval = $interval;
    this.bModal = bModal;
    this.ConnectionQuality = ConnectionQuality;

    this.init();

    this.isPrintView = false;
    this.licensingAgreementPdf = "https://cdn.klix-web.com/2020.02.13_UMOWA_LICENCYJNA_PROGRAMU_Klix_R&P.pdf";
    this.fields = {
      name: "name",
      email: "email",
      legalRole: "role",
      legalEntityRole: "role",
      status: "status"
    };

    this.globalActions = [
      {
        name: "new",
        functionName: "startSendingNewInvitation",
        fa: "fa-plus"
      }
    ];

    this.rowActions = [
      {
        name: "view",
        functionName: "goToAgreementForm",
        class: "Accepted"
      },
      {
        name: "download",
        functionName: "downloadAgreementForm",
        fa: "fa-download",
        class: "Accepted"
      },
      {
        name: "resend",
        functionName: "resendInvitation",
        class: "Waiting"
      },
      {
        name: "cancel",
        functionName: "startCancellingInvitation",
        class: "Waiting"
      }
    ];

    this.newInvitationData = {
      email: {
        type: "text",
      },
      name: {
        type: "text",
      },
      legalRole: {
        type: "text",
      },
      legalEntityRole: {
        type: "text",
      }
    };

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  init() {
    this.state = "loading";
    this.Auth.authorizeAdmin().then(
      (user) => {
        this.user = user;
        if (!this.user.isAdmin) {
          if (!this.user.isLocalAdmin)
            this.Auth.handleUnauthorized();
        }

        this.state = "loaded";
        this.Admin.getInvitations().then(
          (success) => {
            this.invitations = success.data.sort((a, b) => a.name.localeCompare(b.name));
            this.state = "loaded";
          },
          (error) => {
            this.state = "loaded";
            this.Notes.postNote({type: "error", error: error});
          }
        );

        var timeout = this.$interval(() => {
          this.notes = this.Notes.getNotes();
        }, 10);
        this.$scope.$on("$destroy", () => {this.$interval.cancel(timeout);});
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );
  }

  startSendingNewInvitation() {
    this.newInvitationProcess = true;
    this.newInvitationValues = null;
  }

  sendNewInvitation(invitation) {
    if (this.state == "loading")
      return;

    this.state = "loading";

    let dto = {
      email: invitation.email,
      name: invitation.name,
      legalRole: invitation.legalRole,
      legalEntityRole: invitation.legalEntityRole
    };

    this.Admin.sendInvitation(dto).then(
      () => {
        this.newInvitationProcess = false;
        this.init();
        this.Notes.postNote({type: "success"});
      },
      (error) => {
        this.state = "loaded";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  downloadAgreementForm(form) {
    this.state = "loading";

    this.isPrintView = true;

    this.Auth.getLicenseAgreementById(form.formId).then(
      ({data}) => {
        return this.Auth.getLicenseAgreementAttachments(form.formId).then((attachments) => {
          this.printData = {
            licensingAgreementPdf: this.licensingAgreementPdf,
            createdAt: moment(data.createdAt).format("DD.MM.YYYY") || moment().format("DD.MM.YYYY"),
            invoicingData: {
              company: data.company,
              country: data.country,
              address1: data.address1,
              address2: data.address2,
              intraCommunityVatNumber: data.intraCommunityVatNumber,
              localVatNumber: data.localVatNumber,
              taxIdNumber: data.taxIdNumber,
              phoneNumber: data.phoneNumber,
              invoicesEmailAddress: data.invoicesEmailAddress
            },
            contactData: {
              mainContactPersonName: data.mainContactPersonName,
              mainContactPersonEmailAddress: data.mainContactPersonEmailAddress,
              mainContactPersonPhoneNumber: data.mainContactPersonPhoneNumber
            },
            consents: {
              licenseAgreementAccepted: data.licenseAgreementAccepted,
              dataProcessingAgreementAccepted: data.dataProcessingAgreementAccepted
            },
            taxCertificateOfResidenceRequired: data.taxCertificateOfResidenceRequired,
            attachments: attachments.data
          };

          if (!this.printData.invoicingData.localVatNumber) delete this.printData.invoicingData.localVatNumber;
          if (!this.printData.invoicingData.intraCommunityVatNumber) delete this.printData.invoicingData.intraCommunityVatNumber;
          if (!this.printData.invoicingData.address2) delete this.printData.invoicingData.address2;

          setTimeout(() => {
            this.state = angular.copy(this.state);
            this.isPrintView = angular.copy(this.isPrintView);

            html2canvas(document.getElementById("license-print"), {
              scale: 2
            })
            .then(function (canvas) {
              var data = canvas.toDataURL();

              var docDefinition = {
                pageOrientation: "portrait",
                pageMargins: [0, 0, 0, 0],
                pageSize: {
                  width: 595.28,
                  height: "auto"
                },
                content: [{
                  image: data,
                  width: 595.28,
                  pages: 2,
                  pageOrientation: "portrait"
                }],
              };
              pdfMake.createPdf(docDefinition).download("license-agreement.pdf");
            }).then(() => {
              this.isPrintView = false;
              this.state = "loaded";
            });
          }, 2);
        });
      },
        error => {
          this.state = error;
          this.Notes.postNote({type: "error", error: error});
        }
      );
  }

  resendInvitation(invitation) {
    this.modalConfig = {
      text: "LICENSE_AGREEMENTS.CONFIRMATION.RESEND",
      cancelText: "CANCEL",
      acceptText: "SUBMIT"
    };

    this.bModal.show(this.modalConfig).then(
      () => {
        this.Admin.resendInvitation(invitation.id, invitation.email).then(
          () => {
            this.state = "loaded";
            this.Notes.postNote({type: "successResend"});
          },
          (error) => {
            this.state = "loaded";
            this.Notes.postNote({type: "error", error: error});
          }
        );
      },
      () => {}
    );
  }

  startCancellingInvitation(invitation) {
    this.cancelInvitationProcess = true;
    this.cancelInvitationValues = invitation;
  }

  cancelInvitation(invitation) {
    if (this.state == "loading")
      return;

    this.state = "loading";

    this.Admin.deleteInvitation(invitation.id).then(
      () => {
        this.cancelInvitationProcess = false;
        this.init();
      },
      (error) => {
        this.state = "loaded";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  goToAgreementForm(form) {
    window.open(`/license-agreement-forms/${form.formId}`, "_blank");
  }

  underscoreString(string) {
    return string.split(/(?=[A-Z])/).join("_").toUpperCase();
  }
}
